export default function NotFound() {
  return (
    <div className="min-h-screen bg-background-50 flex flex-col items-center justify-center text-center px-4">
      <div className="w-20 h-20 flex items-center justify-center rounded-full bg-background-100 mb-6">
        <i className="ri-emotion-sad-line text-3xl text-foreground-300"></i>
      </div>
      <h1 className="text-2xl font-heading font-bold text-foreground-950 mb-2">404 - 页面未找到</h1>
      <p className="text-foreground-500 mb-6 max-w-md">
        抱歉，您访问的页面不存在。请检查网址是否正确，或返回首页继续浏览。
      </p>
      <a
        href="/"
        className="px-6 py-3 rounded-lg bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap"
      >
        返回首页
      </a>
    </div>
  );
}